import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import SignupForm from '../SignupForm';

import HeroImage from './images/heroImage.jpg';
import CallActionImage from './images/callActionBackground.jpg';
import referenceImage from './images/reference.jpg';

import './HomeView.scss';

class HomeView extends React.Component {
  constructor (props) {
    super(props);

    this.ScrollToAction = this.ScrollToAction.bind(this);
  }

  ScrollToAction () {
    const node = ReactDOM.findDOMNode(this.refs.CallToAction);

    if (node) {
      node.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  render () {
    return (
      <div className='HomeView'>
        <div className='HomeView__HeroWrapper'>
          <div className='HomeView_ColorOverlay'>
            <div className='container'>
              <h2>Free Access to Hardworking Interns</h2>
              <p className='HomeView__TagLine'>Our internship recruitment service matches college & grad talent to your needs, quickly and painlessly</p>
              {(this.props.authenticatedID !== null)
              ? <a className='HomeView__StartedButton' href='/company/home'>Get Started Now</a>
              : <a onClick={this.ScrollToAction} className='HomeView__StartedButton'>GET STARTED FOR FREE</a>}
            </div>
          </div>
          <div className='HomeView__InternalWrapper'>
            <img src={HeroImage} />
          </div>
        </div>
        <div className='container'>
          <div className='sectionWrapper'>
            <div className='row'>
              <div className='col-md-8'>
                <p className='HomeView__Quote'>
  "I was most impressed by the poise and intelligence of Leo, an NYU junior, double majoring in computer science and engineering.
  Credentials aside, the dedication and commitment to his experience with us are what make me believe that his impact will far outlast his internship with us."
                </p>
              </div>
              <div className='col-md-4'>
                <div className='row'>
                  <div className='col-5'>
                    <div className='clearfix'>
                      <div className='ReferenceBlock__ImageWrap'>
                        <img src={referenceImage} />
                      </div>
                    </div>
                  </div>
                  <div className='col-7'>
                    <h5>Smith Sirisakorn</h5>
                    <h6>Managing Partner at Fairthorne Ventures</h6>
                  </div>
                </div>
                <div className='row'>
                  <div className='col'>
                    <p className='ReferenceBlock__HireTime'>Smith hired Leo as an intern and managed him last summer</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='sectionWrapper sectionWrapper--Blue'>
          <div className='container ReasonsBlock__Wrapper'>
            <div className='row'>
              <div className='col-sm-4 ReasonsBlock__Entry'>
                <h3>Free</h3>
                <p>Our service is 100% free for companies</p>
              </div>
              <div className='col-sm-4 ReasonsBlock__Entry'>
                <h3>Qualified Interns</h3>
                <p>Our trained career experts use algorithms plus years of experience to match students that fit your needs</p>
              </div>
              <div className='col-sm-4 ReasonsBlock__Entry'>
                <h3>Save Time</h3>
                <p>We do the screening, and you choose to interview or hire them only if you wish</p>
              </div>
            </div>
          </div>
        </div>
        <div className='HomeView__CallAction' ref='CallToAction'>
          <div className='HomeView_ColorOverlay'>
            <div className='container'>
              <div className='row'>
                <div className='col-sm'>
                  <h2 style={{ textAlign: 'center' }}>Your perfect Intern is waiting for you.<br /> Sign up today</h2>
                  {(this.props.authenticatedID !== null)
                  ? <a className='HomeView__StartedButton' style={{ marginTop: '35px' }} href='/company/home'>Get Started Now</a>
                  : <SignupForm />}
                </div>
              </div>
            </div>
          </div>
          <div className='HomeView__InternalWrapper'>
            <img src={CallActionImage} />
          </div>
        </div>
        <footer>
          <p className='copy'>&copy; Paragon One 2017</p>
        </footer>
      </div>
    );
  }
}

// {(props.authenticatedID === null) ? <SignupForm />
//   : <Link to='/company/create'>Click here to create a company</Link>}

const mapStateToProps = state => ({
  authenticatedID: state.auth.sub || null
});

export default connect(
  mapStateToProps
)(HomeView);



// WEBPACK FOOTER //
// ./src/routes/company/routes/Landing/components/HomeView/index.js